import { useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import TittleLine from "../../../components/Common/TittleLine";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomWindows from "../../../components/CustomWindows/CustomWindows";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomCheckbox from "../../../components/CustomForm/CustomCheckbox";
import HojaQuirurgicaForm from "../components/HojaQuirurgicaForm";
import ModalVisualizadorDocumentos from "../components/ModalVisualizadorDocumentos";
import ModalCorreoValidacion from "../components/ModalCorreoValidacion";

import {
  ContainerWrapper,
  ContentContainer,
} from "../styles/DetallesPacienteStyles";

import PatientInfoCard from "../components/PatientInfoCard";
import ActionButtons from "../components/ActionButtons";
import LoadingState from "../components/LoadingState";
import NotFoundState from "../components/NotFoundState";
import ValidacionesModals from "../components/ValidacionesModals";

import useValidacionesHojaQX from "../hooks/useValidacionesHojaQX";
import useValidacionesModals from "../hooks/useValidacionesModals";
import useCrearValidacionHojaQX from "../hooks/useCrearValidacionHojaQX";
import useCrearValidacionHojaQXHandlers from "../hooks/useCrearValidacionHojaQXHandlers";

import PrestadorActions from "../../../stores/prestador/Actions";
import HojasQuirurgicasActions from "../../../stores/hospitalizacion/hojasQuirurgicas/Actions";
import OrdsInfoplanActions from "../../../stores/ordsInfoplan/Actions";
import AuthActions from "../../../stores/auth/Actions";

const CrearValidacionHojaQXScreen = (props) => {
  const { numeroIngreso } = useParams();
  const [pertinenciaMedica, setPertinenciaMedica] = useState(false);

  const {
    authUserData,
    consultarPaciente,
    consultarPacienteData,
    consultarPacientesData,
    getProcedimientosPssData,
    getProcedimientosPssLoading,
    getProcedimientosPssError,
    getMedicosData,
    getMedicosLoading,
    getMedicosError,
    consultarTipoPssNoMedicoData,
    consultarTipoPssNoMedicoLoading,
    validarHojaQuirurgicaData,
    validarHojaQuirurgicaLoading,
    validarHojaQuirurgicaError,
    getProcedimientosPss,
    getMedicos,
    obtenerEspecialidadesMedicas,
    obtenerEspecialidadesMedicasData,
    obtenerEspecialidadesMedicasLoading,
    obtenerEspecialidadesMedicasError,
    consultarPacienteLoading,
  } = props;

  const {
    pacienteIngresado,
    coberturasMedicos,
    documentosAnexos,
    coberturasCompletas,
    coberturasEnviadas: coberturasEnviadasSet,
    archivosEnviados,
    hojaQuirurgicaLoading,
    enviandoCoberturas,
    coberturasDuplicadas,
    coberturasDuplicadasIds,
    resultadoEnvioPendiente,
    todasLasCoberturasEnviadasODuplicadas,
    handleSubmitHojaQuirurgica,
    handleEnviarCoberturas,
    handleEliminarCobertura,
    handleEliminarAnexo,
    setResultadoEnvioPendiente,
  } = useValidacionesHojaQX({
    authUserData,
    consultarPaciente,
    consultarPacienteData,
    consultarPacientesData,
    consultarTipoPssNoMedicoData,
    obtenerEspecialidadesMedicas,
  });

  const {
    showHojaQuirurgicaModal,
    modalVisible,
    documentoModal,
    showCoberturasRequeridasAlert,
    showResultadoEnvioModal,
    resultadoEnvio,
    showConfirmarEliminarCobertura,
    showConfirmarEliminarAnexo,
    showCoberturasDuplicadasModal,
    showUploadResultsModal,
    showModalEncuestaSatisfaccion,
    abrirModalDocumento,
    cerrarModalDocumento,
    handleOpenHojaQuirurgicaModal,
    handleCloseHojaQuirurgicaModal,
    handleCloseCoberturasRequeridasAlert,
    handleEliminarCobertura: handleEliminarCoberturaModal,
    confirmarEliminarCobertura,
    cancelarEliminarCobertura,
    handleEliminarAnexo: handleEliminarAnexoModal,
    confirmarEliminarAnexo,
    cancelarEliminarAnexo,
    handleCerrarCoberturasDuplicadasModal,
    setShowCoberturasRequeridasAlert,
    setShowResultadoEnvioModal,
    setResultadoEnvio,
    setShowUploadResultsModal,
    setShowModalEncuestaSatisfaccion,
    showCirugiasLiberadasModal,
    cirugiasLiberadasData,
    handleCerrarCirugiasLiberadasModal,
    setShowCirugiasLiberadasModal,
    setCirugiasLiberadasData,
    showConfirmarEnvioCoberturas,
    handleCerrarConfirmarEnvioCoberturas,
    setShowConfirmarEnvioCoberturas,
  } = useValidacionesModals();

  const {
    handleEnviarCoberturasClick,
    handleConfirmarEnvioCoberturas,
    showCorreoValidacionModal,
    handleConfirmarCorreoValidacion,
    handleCerrarCorreoValidacionModal,
    handleIrADetalles,
    handleVolverIngresosClick,
    handleResponderEncuesta,
    comentarioValidacion,
    handleComentarioChange,
    handleBack,
    windows,
    showModalEncuestaCes,
    showEncuestaCesIframe,
    handleResponderEncuestaCes,
    handleCerrarEncuestaCesIframe,
    handleCerrarResultadoEnvioModal,
  } = useCrearValidacionHojaQX({
    handleEnviarCoberturas,
    setShowCoberturasRequeridasAlert,
    setShowResultadoEnvioModal,
    setResultadoEnvio,
    pacienteIngresado,
    setShowModalEncuestaSatisfaccion,
    authUserData,
    updatePrestadorCorreo: props.updatePrestadorCorreo,
    consultarTipoPssNoMedicoData,
    coberturasMedicos,
    documentosAnexos,
    coberturasEnviadasSet,
    archivosEnviados,
    coberturasDuplicadasIds,
    coberturasCompletas,
    handleEliminarCoberturaModal,
    handleEliminarAnexoModal,
    abrirModalDocumento,
    setShowCirugiasLiberadasModal,
    setCirugiasLiberadasData,
    setShowConfirmarEnvioCoberturas,
    pertinenciaMedica,
  });

  const {
    handleConfirmarEliminarCobertura,
    handleConfirmarEliminarAnexo,
    handleCerrarCoberturasDuplicadas,
    handleSubmitForm,
  } = useCrearValidacionHojaQXHandlers({
    confirmarEliminarCobertura,
    handleEliminarCobertura,
    confirmarEliminarAnexo,
    handleEliminarAnexo,
    handleCerrarCoberturasDuplicadasModal,
    resultadoEnvioPendiente,
    setResultadoEnvio,
    setShowResultadoEnvioModal,
    setResultadoEnvioPendiente,
    handleSubmitHojaQuirurgica,
    handleCloseHojaQuirurgicaModal,
  });


  if (consultarPacienteLoading) {
    return <LoadingState />;
  }

  if (!pacienteIngresado) {
    return <NotFoundState numeroIngreso={numeroIngreso} onBack={handleBack} />;
  }

  return (
    <CustomLayout
      showMenuNav={true}
      footerWidth="auto"
      marginContainer="0 0 100px 0"
    >
      <Section>
        <TittleLine title="Validación de Hoja Quirúrgica" weight="bold" />
      </Section>

      <CustomSeparator height={"20px"} />
      <ContainerWrapper>
        <ContentContainer>
          <CustomSeparator height={"20px"} />

          <PatientInfoCard pacienteIngresado={pacienteIngresado} />

          <CustomSeparator height={"20px"} />

          <Section width="100%" display="flex" justify="flex-start">
            <div>
              <CustomInput
                type="text"
                label="Comentario de validación"
                placeholder={pertinenciaMedica ? "Ingrese un comentario (obligatorio)" : "Ingrese un comentario (opcional)"}
                value={comentarioValidacion}
                onChange={handleComentarioChange}
                width="100%"
                disabled={enviandoCoberturas}
                required={pertinenciaMedica}
                testid="input-comentario-validacion"
              />
              <CustomSeparator height={"12px"} />
              <CustomCheckbox
                label="Pertinencia médica"
                checked={pertinenciaMedica}
                onChange={(e) => setPertinenciaMedica(e.target.checked)}
              />
            </div>
          </Section>

          <CustomSeparator height={"20px"} />

          <ActionButtons
            onAgregarCobertura={handleOpenHojaQuirurgicaModal}
            onEnviarCoberturas={handleEnviarCoberturasClick}
            isLoading={consultarTipoPssNoMedicoLoading}
            disabled={todasLasCoberturasEnviadasODuplicadas}
            enviandoCoberturas={enviandoCoberturas}
          />

          <CustomSeparator height={"20px"} />

          <Section
            style={{
              height: "100%",
              minHeight: "600px",
              width: "100%",
            }}
          >
            <CustomWindows
              windows={windows}
              defaultActiveWindow={0}
              tabPosition="top"
              onWindowChange={() => {}}
            />
          </Section>
        </ContentContainer>
      </ContainerWrapper>

      <CustomModal isOpen={showHojaQuirurgicaModal} showCloseButton={false}>
        <Section maxHeight="80vh" overflowY="auto">
          <HojaQuirurgicaForm
            onSubmit={handleSubmitForm}
            onCancel={handleCloseHojaQuirurgicaModal}
            paciente={pacienteIngresado}
            isLoading={hojaQuirurgicaLoading}
            authUserData={authUserData}
            getProcedimientosPssData={getProcedimientosPssData}
            getProcedimientosPssLoading={getProcedimientosPssLoading}
            getProcedimientosPssError={getProcedimientosPssError}
            getMedicosData={getMedicosData}
            getMedicosLoading={getMedicosLoading}
            getMedicosError={getMedicosError}
            getProcedimientosPss={getProcedimientosPss}
            getMedicos={getMedicos}
            consultarTipoPssNoMedicoData={consultarTipoPssNoMedicoData}
            validarHojaQuirurgicaData={validarHojaQuirurgicaData}
            validarHojaQuirurgicaLoading={validarHojaQuirurgicaLoading}
            validarHojaQuirurgicaError={validarHojaQuirurgicaError}
            obtenerEspecialidadesMedicas={obtenerEspecialidadesMedicas}
            obtenerEspecialidadesMedicasData={obtenerEspecialidadesMedicasData}
            obtenerEspecialidadesMedicasLoading={
              obtenerEspecialidadesMedicasLoading
            }
            obtenerEspecialidadesMedicasError={
              obtenerEspecialidadesMedicasError
            }
            coberturasEnviadas={coberturasEnviadasSet}
            archivosEnviados={archivosEnviados}
            coberturasCompletas={coberturasCompletas}
          />
        </Section>
      </CustomModal>

      <ModalVisualizadorDocumentos
        visible={modalVisible}
        documento={documentoModal}
        onClose={cerrarModalDocumento}
      />

      <ModalCorreoValidacion
        isOpen={showCorreoValidacionModal}
        onClose={handleCerrarCorreoValidacionModal}
        onConfirm={handleConfirmarCorreoValidacion}
        correoActual={authUserData?.prestador?.correoElectronico}
        telefono={
          authUserData?.prestador?.celular ||
          authUserData?.prestador?.telefono ||
          ""
        }
      />

      <ValidacionesModals
        showCoberturasRequeridasAlert={showCoberturasRequeridasAlert}
        onCloseCoberturasRequeridas={handleCloseCoberturasRequeridasAlert}
        showResultadoEnvioModal={showResultadoEnvioModal}
        resultadoEnvio={resultadoEnvio}
        onVolverIngresos={handleVolverIngresosClick}
        onIrADetalles={handleIrADetalles}
        showConfirmarEliminarCobertura={showConfirmarEliminarCobertura}
        onConfirmarEliminarCobertura={handleConfirmarEliminarCobertura}
        onCancelarEliminarCobertura={cancelarEliminarCobertura}
        showConfirmarEliminarAnexo={showConfirmarEliminarAnexo}
        onConfirmarEliminarAnexo={handleConfirmarEliminarAnexo}
        onCancelarEliminarAnexo={cancelarEliminarAnexo}
        showCoberturasDuplicadasModal={showCoberturasDuplicadasModal}
        coberturasDuplicadas={coberturasDuplicadas}
        onCerrarCoberturasDuplicadas={handleCerrarCoberturasDuplicadas}
        showCirugiasLiberadasModal={showCirugiasLiberadasModal}
        cirugiasLiberadasData={cirugiasLiberadasData}
        onCerrarCirugiasLiberadas={handleCerrarCirugiasLiberadasModal}
        showConfirmarEnvioCoberturas={showConfirmarEnvioCoberturas}
        onConfirmarEnvioCoberturas={handleConfirmarEnvioCoberturas}
        onCancelarEnvioCoberturas={handleCerrarConfirmarEnvioCoberturas}
        showUploadResultsModal={showUploadResultsModal}
        uploadedFilesResults={[]}
        onCloseUploadResults={() => setShowUploadResultsModal(false)}
        showModalEncuestaSatisfaccion={showModalEncuestaSatisfaccion}
        onResponderEncuesta={handleResponderEncuesta}
        showModalEncuestaCes={showModalEncuestaCes}
        showEncuestaCesIframe={showEncuestaCesIframe}
        onResponderEncuestaCes={handleResponderEncuestaCes}
        onCerrarEncuestaCesIframe={handleCerrarEncuestaCesIframe}
        onCerrarResultadoEnvio={handleCerrarResultadoEnvioModal}
      />
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  consultarPacienteData: state.hospitalizacion.consultarPacienteData,
  consultarPacienteLoading: state.hospitalizacion.consultarPacienteLoading,
  consultarPacienteError: state.hospitalizacion.consultarPacienteError,
  consultarPacientesData: state.hospitalizacion.consultarPacientesData,
  consultarPacientesLoading: state.hospitalizacion.consultarPacientesLoading,
  consultarPacientesError: state.hospitalizacion.consultarPacientesError,
  getProcedimientosPssData: state.prestador.getProcedimientosPssData,
  getProcedimientosPssLoading: state.prestador.getProcedimientosPssLoading,
  getProcedimientosPssError: state.prestador.getProcedimientosPssError,
  getMedicosData: state.prestador.getMedicosData,
  getMedicosLoading: state.prestador.getMedicosLoading,
  getMedicosError: state.prestador.getMedicosError,
  consultarTipoPssNoMedicoData: state.prestador.consultarTipoPssNoMedicoData,
  consultarTipoPssNoMedicoLoading:
    state.prestador.consultarTipoPssNoMedicoLoading,
  validarHojaQuirurgicaData: state.hospitalizacion.validarHojaQuirurgicaData,
  validarHojaQuirurgicaLoading:
    state.hospitalizacion.validarHojaQuirurgicaLoading,
  validarHojaQuirurgicaError: state.hospitalizacion.validarHojaQuirurgicaError,
  consultarEstatusHojasQXData:
    state.hospitalizacion.consultarEstatusHojasQXData,
  consultarEstatusHojasQXLoading:
    state.hospitalizacion.consultarEstatusHojasQXLoading,
  consultarEstatusHojasQXError:
    state.hospitalizacion.consultarEstatusHojasQXError,
  obtenerEspecialidadesMedicasData:
    state.ordsInfoplan.obtenerEspecialidadesMedicasData,
  obtenerEspecialidadesMedicasLoading:
    state.ordsInfoplan.obtenerEspecialidadesMedicasLoading,
  obtenerEspecialidadesMedicasError:
    state.ordsInfoplan.obtenerEspecialidadesMedicasError,
});

const mapDispatchToProps = {
  consultarPaciente: HojasQuirurgicasActions.consultarPaciente,
  getProcedimientosPss: PrestadorActions.getProcedimientosPss,
  getMedicos: PrestadorActions.getMedicos,
  consultarEstatusHojasQX: HojasQuirurgicasActions.consultarEstatusHojasQX,
  obtenerEspecialidadesMedicas:
    OrdsInfoplanActions.obtenerEspecialidadesMedicas,
  updatePrestadorCorreo: AuthActions.updatePrestadorCorreo,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CrearValidacionHojaQXScreen);
